import React, { useState } from 'react';
import styles from './GroupList.module.css';
import GroupEditModal from '../GroupEditModal/GroupEditModal'; 
import GroupEntryModal from '../GroupEntryModal/GroupEntryModal'; 

const GroupList = ({ data, isLoading, onRefresh }) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEntryModal, setShowEntryModal] = useState(false); 
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [activeDetailId, setActiveDetailId] = useState(null); 
  const [activeGroup, setActiveGroup] = useState(null); 

  if (isLoading) return null;

  const groups = data || [];
  const dayNames = { 1: "B.E.", 2: "Ç.A.", 3: "Çərş.", 4: "C.A.", 5: "Cümə", 6: "Şən.", 7: "Baz." };
  const sectorNames = { 'az': 'Azərbaycan bölməsi', 'rus': 'Rus bölməsi', 'eng': 'İngilis bölməsi' };

  const handleOpenSettings = (group) => {
    setSelectedGroupId(group.id);
    setSelectedGroup(group);
    setShowEditModal(true);
  };

  const handleOpenEntry = (group) => {
    setActiveGroup(group);
    setShowEntryModal(true);
    localStorage.setItem('activeContractTrainingId', group.contractTrainingId ?? '');
  };

  const handleCloseModals = () => {
    setShowEditModal(false);
    setShowEntryModal(false);
    setSelectedGroupId(null);
    setSelectedGroup(null);
  };

  if (groups.length === 0) {
    return (
      <div className="text-center mt-4 p-4 border rounded bg-light shadow-sm">
        <i className="bi bi-folder-x display-6 text-muted"></i>
        <p className="mt-2 text-muted small">Bu kateqoriyada heç bir qrup tapılmadı.</p>
      </div>
    );
  }

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '16px' }}>
        {groups.map((group) => {
          const scheduleIncomplete =
            group.weeklyLessonCount != null &&
            (group.groupLessonDays?.length ?? 0) !== group.weeklyLessonCount;

          return (
          <div key={group.id}>
            <div className={styles.customCard}>
              
              <div className={`${styles.detailOverlay} ${activeDetailId === group.id ? styles.active : ''}`}>
                <button className={styles.closeOverlayBtn} onClick={() => setActiveDetailId(null)}>
                  <i className="bi bi-x-circle-fill"></i>
                </button>
                <div className={styles.detailContent}>
                   <div className={styles.detailItem}>
                     <span>Bölmə:</span>
                     <strong>{group.sector ? (sectorNames[group.sector.toLowerCase()] || group.sector) : 'Yoxdur'}</strong>
                   </div>
                   <div className={styles.detailItem}>
                     <span>Başlama tarixi:</span>
                     <strong>{group.beginDate || '1900-01-01'}</strong>
                   </div>
                   <div className={styles.detailItem}>
                     <span>Müddət:</span>
                     <strong>{group.courseLength || "Yoxdur"} ay</strong>
                   </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center py-1 mb-1">
                <span className="text-success fw-bold" style={{fontSize: '13px'}}>Təlim:</span>
                <span className="text-truncate ms-2 text-end fw-bold text-dark" style={{fontSize: '13px'}} title={group.trainingName}>
                  {group.trainingName}
                </span>
              </div>

              <div className="d-flex justify-content-between py-1 mb-1">
                <span className="text-secondary" style={{fontSize: '12px'}}>Qrup:</span>
                <span className="fw-bold text-dark" style={{fontSize: '12px'}}>{group.name}</span>
              </div>

              <div className="d-flex justify-content-between py-1 mb-1 border-bottom pb-2">
                <span className="text-secondary" style={{fontSize: '12px'}}>Tələbə:</span>
                <span className="badge bg-info text-white rounded-pill px-2 py-1" style={{ fontSize: '10px' }}>
                  {group.studentCount || 0} nəfər
                </span>
              </div>
              
              <div className="mt-2">
                <p className="fw-bold text-secondary mb-1 d-flex align-items-center" style={{fontSize: '12px'}}>
                  <i className="bi bi-calendar3 me-1 text-success"></i> Qrafik:
                </p>
                <div className={styles.lessonsBox}>
                  <div className="d-flex flex-column gap-1 w-100 px-2 py-2">
                    {group.groupLessonDays && group.groupLessonDays.length > 0 ? (
                      group.groupLessonDays.map((lesson) => (
                        <div key={lesson.id} className="d-flex justify-content-between align-items-center border-bottom pb-1 mb-1" style={{ fontSize: '11px' }}>
                          <span className="text-dark">{dayNames[lesson.day] || lesson.day}:</span>
                          <span className="text-primary fw-bold">{lesson.hour?.substring(0, 5)}</span>
                        </div>
                      ))
                    ) : (
                      <div className="text-muted text-center w-100 py-2" style={{fontSize: '11px'}}>Məlumat tapılmadı</div>
                    )}
                    {scheduleIncomplete && (
                      <div className={styles.entryHint} onClick={() => handleOpenSettings(group)}>
                        <div>
                          <i className="bi bi-lock-fill"></i>
                          "Daxil ol" aktiv deyil
                        </div>
                        <div className={styles.entryHintLink}>
                          həftəlik {group.weeklyLessonCount} dərsin qrafikini təyin edin
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="pt-2 mt-auto">
                <div className="d-flex gap-1">
                  <button
                    className={scheduleIncomplete ? styles.btnActionDisabled : styles.btnAction}
                    style={{padding: '6px', fontSize: '12px'}}
                    onClick={() => !scheduleIncomplete && handleOpenEntry(group)}
                    disabled={scheduleIncomplete}
                  >
                    <i className="bi bi-box-arrow-in-right me-1"></i> Daxil ol
                  </button>

                  <button
                    className={styles.btnIcon}
                    title="Ətraflı"
                    onClick={() => setActiveDetailId(group.id)}
                  >
                    <i className="bi bi-list fs-6"></i>
                  </button>

                  <button
                    className={`${styles.btnIcon} ${scheduleIncomplete ? styles.btnIconWarning : ''}`}
                    title={scheduleIncomplete ? 'Qrafiki təyin et' : 'Redaktə et'}
                    onClick={() => handleOpenSettings(group)}
                  >
                    <i className={`bi bi-gear ${scheduleIncomplete ? styles.gearSpin : ''}`} style={{fontSize: '14px', display: 'block'}}></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          );
        })}
      </div>

      <GroupEditModal 
        show={showEditModal} 
        handleClose={handleCloseModals} 
        groupId={selectedGroupId}
        groupData={selectedGroup}
        onSuccess={onRefresh} 
      />

      <GroupEntryModal
        show={showEntryModal}
        handleClose={handleCloseModals}
        group={activeGroup}
      />
    </>
  );
};

export default GroupList;